import { getSafeRedirectUrl } from './url';

export const paymentSuccessGoBack = (paymentReturnTo: string) => {
  if (typeof window === 'undefined') return;

  if (window.opener) {
    window.close();
    return;
  }

  if (paymentReturnTo) {
    window.location.href = getSafeRedirectUrl(paymentReturnTo);
    return;
  }

  window.history.go(-2);
};
